import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SectionWeServeFor = () => {
  const { t } = useTranslation();
  const [hoverColors, setHoverColors] = useState<Record<number, string>>({});
  const colorPool = ['#D7D3F7', '#05C0FF', '#55DB9C', '#7A69FA'];

  const handleMouseEnter = (index: number) => {
    const randomColor = colorPool[Math.floor(Math.random() * colorPool.length)];
    setHoverColors((prev) => ({ ...prev, [index]: randomColor }));
  };

  const handleMouseLeave = (index: number) => {
    setHoverColors((prev) => {
      const newColors = { ...prev };
      delete newColors[index];
      return newColors;
    });
  };
  const solutions = [
    t('Crypto Influencers'),
    t('Investment Companies'),
    t('Asset Managers'),
    t('Trading Academies'),
    t('Financial Advisors/Wealth Tech'),
    t('Online Trading Communities'),
    t('Individual Trading Experts'),
    t('Crypto Media/News Platforms'),
    t('Blockchain Projects'),
    t('Web3 Service Providers'),
    t('Corporate Finance Managers'),
    t('Startups'),
  ];
  return (
    <section className="solution">
      <div className="title-section">
        <p className="title">{t('We Serve For')}</p>
        <span className="tag">(12)</span>
      </div>
      <div className="layout-grid">
        {solutions.map((item, index) => (
          <div
            key={index}
            className="grid-item"
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave(index)}
            style={hoverColors[index] ? { backgroundColor: hoverColors[index] } : {}}
          >
            {item}
          </div>
        ))}
      </div>
    </section>
  );
};

export default React.memo(SectionWeServeFor);
